import { render } from "./MainSubtitle.vue?vue&type=template&id=a67eda0e&scoped=true"
import script from "./MainSubtitle.vue?vue&type=script&lang=js"
export * from "./MainSubtitle.vue?vue&type=script&lang=js"

import "./MainSubtitle.vue?vue&type=style&index=0&id=a67eda0e&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67eda0e"]])

export default __exports__